import { render, staticRenderFns } from "./EditProfileUser.vue?vue&type=template&id=56eb85e4&"
import script from "./EditProfileUser.vue?vue&type=script&lang=js&"
export * from "./EditProfileUser.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports